/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Customer_Badge_Awaiting_ApprovalInputs */



/**
* | output |
* | --- |
* | "Awaiting oneAI approval" |
*
* @param {Partner_Customer_Badge_Awaiting_ApprovalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_customer_badge_awaiting_approval = /** @type {((inputs?: Partner_Customer_Badge_Awaiting_ApprovalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Customer_Badge_Awaiting_ApprovalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wartet auf Freigabe durch oneAI")
	return /** @type {LocalizedString} */ ("Awaiting oneAI approval")
});